import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import ResellerTeamsStore from '../../../../../stores/reseller_teams'

import { append } from '../../../../../utils/url'

@inject('auth')
@observer
export default class ResellerTeams extends Component {

  teams = new ResellerTeamsStore()

  componentWillMount() {
    this.teams.load()
  }

  render() {
    return (
      <div className="container padded teams">
        <div className="panel full padded">
          <h2 className="title">Reseller Teams</h2>
          <Link to={append('add-team')}>Add New Reseller Team</Link>

          <table className="zebra">
            <thead>
              <tr style={{textAlign: 'left'}}>
                <th>Name</th>
                <th>Broker</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {this.teams.map(t => (
                <tr key={t.id}>
                  <td><Link to={append(t.id)}>{t.name}</Link></td>
                  <td>{t.broker ? 'Yes' : 'No'}</td>
                  <td>{new Date(t.created_at).toDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/Admin/Resellers/Teams/index.js